import { createServerFn } from "@tanstack/react-start";

import { authMiddleware } from "~/lib/auth-middleware";
import { requireClerkCoachAuth } from "~/lib/coach-middleware";
import {
  AddMilestoneOfLife,
  DeleteMilestoneOfLife,
  GetMilestonesByGoalId,
  MovedMilestoneOfLife,
  RenameMilestoneOfLife,
  SyncMilestonesOfLife,
  UpdateMilestoneStatus,
} from "~/lib/schemas/milestone-of-life";

export const getMilestonesByGoalIdFn = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .validator(GetMilestonesByGoalId)
  .handler(async ({ data, context }) => {
    const { getMilestonesByGoalId } =
      await import("~/lib/server/milestone-of-life");
    return getMilestonesByGoalId(data.goalId, context.user.id);
  });

export const getMilestonesByGoalIdForCoachFn = createServerFn({ method: "GET" })
  .middleware([requireClerkCoachAuth])
  .validator(GetMilestonesByGoalId)
  .handler(async ({ data, context }) => {
    const { getClientGoalMilestonesForCoach } =
      await import("~/lib/server/milestone-of-life");
    return getClientGoalMilestonesForCoach(context.coach.id, data.goalId);
  });

export const updateMilestoneStatusFn = createServerFn({ method: "POST" })
  .middleware([authMiddleware])
  .validator(UpdateMilestoneStatus)
  .handler(async ({ data, context }) => {
    const { updateMilestoneStatus } =
      await import("~/lib/server/milestone-of-life");
    return updateMilestoneStatus(data.id, context.user.id, data.status);
  });

export const moveMilestoneOfLifeFn = createServerFn({ method: "POST" })
  .middleware([authMiddleware])
  .validator(MovedMilestoneOfLife)
  .handler(async ({ data, context }) => {
    const { moveMilestoneOfLife } =
      await import("~/lib/server/milestone-of-life");
    return moveMilestoneOfLife(data.id, data.newOrder, context.user.id);
  });

export const syncMilestonesOfLifeFn = createServerFn({ method: "POST" })
  .middleware([authMiddleware])
  .validator(SyncMilestonesOfLife)
  .handler(async ({ data, context }) => {
    const { syncMilestonesOfLife } =
      await import("~/lib/server/milestone-of-life");
    return syncMilestonesOfLife(data.goalId, context.user.id, data.milestones);
  });

export const addMilestoneOfLifeFn = createServerFn({ method: "POST" })
  .middleware([authMiddleware])
  .validator(AddMilestoneOfLife)
  .handler(async ({ data, context }) => {
    const { addMilestoneOfLife } =
      await import("~/lib/server/milestone-of-life");
    const { goalId, ...step } = data;
    return addMilestoneOfLife(goalId, context.user.id, step);
  });

export const renameMilestoneOfLifeFn = createServerFn({ method: "POST" })
  .middleware([authMiddleware])
  .validator(RenameMilestoneOfLife)
  .handler(async ({ data, context }) => {
    const { renameMilestoneOfLife } =
      await import("~/lib/server/milestone-of-life");
    const { id, ...title } = data;
    return renameMilestoneOfLife(id, context.user.id, title);
  });

export const deleteMilestoneOfLifeFn = createServerFn({ method: "POST" })
  .middleware([authMiddleware])
  .validator(DeleteMilestoneOfLife)
  .handler(async ({ data, context }) => {
    const { deleteMilestoneOfLife } =
      await import("~/lib/server/milestone-of-life");
    return deleteMilestoneOfLife(data.id, context.user.id);
  });
